import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ component, isLogged }) => {
  return isLogged && localStorage.jwtToken ? component : <Navigate to="/login" />;
};

export default ProtectedRoute;
